import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SharedModule } from '@shared/shared.module';
import { CoreComponentsModule } from '@app/core/components/core-components.module';
import { reducers } from './store/reducers';
import { effects } from './store/effects/effects';
import { MasterRoutingModule } from './master-routing.module';
import { CustomMasterModule } from './custom-master.module';
// palmyra-needle-angular-add-module-dependencies-import Do not delete this lone. Palmyra will add service declaration here.

import { EditMyUserComponent } from './edit-my-user/edit-my-user.component';
import { MasterVisualizarUsuarioActionsModule } from '../master/visualizar-usuario/actions/master-visualizar-usuario-actions.module';

import { MasterSearchUserActionsModule } from '../master/search-user/actions/master-search-user-actions.module';

import { MasterSearch1ActionsModule } from '../master/search-1/actions/master-search-1-actions.module';

import { MasterSearch0ActionsModule } from '../master/search-0/actions/master-search-0-actions.module';

import { MasterPerfilUsuarioActionsModule } from '../master/perfil-usuario/actions/master-perfil-usuario-actions.module';

import { MasterPerfilAcessoActionsModule } from '../master/perfil-acesso/actions/master-perfil-acesso-actions.module';

import { MasterMasterHomeActionsModule } from '../master/master-home/actions/master-master-home-actions.module';

import { MasterFundosActionsModule } from '../master/fundos/actions/master-fundos-actions.module';

import { MasterEdit5ActionsModule } from '../master/edit-5/actions/master-edit-5-actions.module';

import { MasterEdit1ActionsModule } from '../master/edit-1/actions/master-edit-1-actions.module';

import { MasterEdit0ActionsModule } from '../master/edit-0/actions/master-edit-0-actions.module';
import { MasterCreateUserActionsModule } from '../master/create-user/actions/master-create-user-actions.module';
import { MasterCreateUserWizardActionsModule } from '../master/create-user-wizard/actions/master-create-user-wizard-actions.module';
import { MasterConsultaUsuariosActionsModule } from '../master/consulta-usuarios/actions/master-consulta-usuarios-actions.module';
import { MasterConsultaFundosActionsModule } from '../master/consulta-fundos/actions/master-consulta-fundos-actions.module';
import { MasterConsultaClientesActionsModule } from '../master/consulta-clientes/actions/master-consulta-clientes-actions.module';
import { MasterConfirmedMessageActionsModule } from '../master/confirmed-message/actions/master-confirmed-message-actions.module';
import { MasterCompArrayFormClientsActionsModule } from '../master/comp-array-form-clients/actions/master-comp-array-form-clients-actions.module';
import { MasterAssociarFundosActionsModule } from '../master/associar-fundos/actions/master-associar-fundos-actions.module';
import { MasterAccessProfileActionsModule } from '../master/access-profile/actions/master-access-profile-actions.module';
// palmyra-needle-angular-add-screen-import Do not delete this line. Palmyra will add import screen here
import { MasterVisualizarUsuarioComponent } from './visualizar-usuario/master-visualizar-usuario.component';
import { MasterSearchUserComponent } from './search-user/master-search-user.component';
import { MasterSearch1Component } from './search-1/master-search-1.component';
import { MasterSearch0Component } from './search-0/master-search-0.component';
import { MasterPerfilUsuarioComponent } from './perfil-usuario/master-perfil-usuario.component';
import { MasterPerfilAcessoComponent } from './perfil-acesso/master-perfil-acesso.component';
import { MasterHomeComponent } from './master-home/master-home.component';
import { MasterFundosComponent } from './fundos/master-fundos.component';
import { MasterEdit5Component } from './edit-5/master-edit-5.component';
import { MasterEdit1Component } from './edit-1/master-edit-1.component';
import { MasterEdit0Component } from './edit-0/master-edit-0.component';
import { MasterCreateUserComponent } from './create-user/master-create-user.component';
import { MasterCreateUserWizardComponent } from './create-user-wizard/master-create-user-wizard.component';
import { MasterConsultaUsuariosComponent } from './consulta-usuarios/master-consulta-usuarios.component';
import { MasterConsultaClientesComponent } from './consulta-clientes/master-consulta-clientes.component';
import { MasterConfirmedMessageComponent } from './confirmed-message/master-confirmed-message.component';
import { MasterCompArrayFormClientsComponent } from './comp-array-form-clients/master-comp-array-form-clients.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { MasterAssociarFundosComponent } from './associar-fundos/master-associar-fundos.component';
import { MasterAccessProfileComponent } from './access-profile/master-access-profile.component';
import { MasterMasterGroupsActionsModule } from '../master/master-groups/actions/master-master-groups-actions.module';
import { MasterMasterGroupsUsersActionsModule } from '../master/master-groups-users/actions/master-master-groups-users-actions.module';
import { MasterMasterGroupsFundosActionsModule } from '../master/master-groups-fundos/actions/master-master-groups-fundos-actions.module';
import { MasterMasterGroupsComponent } from './master-groups/master-master-groups.component';
import { MasterMasterGroupsUsersComponent } from './master-groups-users/master-master-groups-users.component';
import { MasterMasterGroupsFundosComponent } from './master-groups-fundos/master-master-groups-fundos.component';
import { PresentationCardComponent } from '@app/shared/components/presentation-card/presentation-card.component';//imprt de CARDPRESENTATION
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,  MatTableModule } from "@angular/material";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MasterClienteVisualizarClienteComponent } from './master-cliente-visualizar-cliente/master-cliente-visualizar-cliente.component';
import { MasterMasterComponent } from './master/master-master.component';
import { MasterVisualizarMeuCadastroComponent } from './visualizar-meu-cadastro/master-visualizar-meu-cadastro.component';
import { ParametersSearchSecurityPortfolioMenuComponent } from '../parameters/search-security-portfolio-menu/parameters-search-security-portfolio-menu.component';

/**
 * The Master module feature with all its screens
 *
 * @stable
 */
@NgModule({
  imports: [
    MatPaginatorModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatSortModule,
    CustomMasterModule,
    MasterRoutingModule,
    StoreModule.forFeature('Master', reducers),
    EffectsModule.forFeature(effects),
    SharedModule,
    CoreComponentsModule,
    ReactiveFormsModule,
    FormsModule,
    MatTooltipModule,
    // palmyra-needle-angular-add-module-dependencies-declaration Do not delete this lone. Palmyra will add service declaration here.

    MasterVisualizarUsuarioActionsModule,

    MasterSearchUserActionsModule,

    MasterSearch1ActionsModule,

    MasterSearch0ActionsModule,

    MasterPerfilUsuarioActionsModule,

    MasterPerfilAcessoActionsModule,

    MasterMasterHomeActionsModule,

    MasterFundosActionsModule,

    MasterEdit5ActionsModule,

    MasterEdit1ActionsModule,

    MasterEdit0ActionsModule,

    MasterCreateUserActionsModule,

    MasterCreateUserWizardActionsModule,

    MasterConsultaUsuariosActionsModule,

    MasterConsultaFundosActionsModule,

    MasterConsultaClientesActionsModule,

    MasterConfirmedMessageActionsModule,

    MasterCompArrayFormClientsActionsModule,

    MasterAssociarFundosActionsModule,

    MasterAccessProfileActionsModule,

    MasterMasterGroupsActionsModule,

    MasterMasterGroupsUsersActionsModule,

    MasterMasterGroupsFundosActionsModule,
  ],
  entryComponents: [EditUserComponent],
  providers: [],
  declarations: [
    // palmyra-needle-angular-add-screen-declaration Do not delete this line. Palmyra will add declaration here
    EditMyUserComponent,
    MasterVisualizarUsuarioComponent, MasterMasterGroupsFundosComponent,

    MasterSearchUserComponent,

    MasterSearch1Component,

    MasterSearch0Component,

    MasterPerfilUsuarioComponent,

    MasterPerfilAcessoComponent,

    MasterClienteVisualizarClienteComponent,

    MasterHomeComponent,

    MasterMasterComponent,

    MasterFundosComponent,

    MasterEdit5Component,

    MasterEdit1Component,

    MasterEdit0Component,

    MasterCreateUserComponent,

    MasterCreateUserWizardComponent,

    MasterConsultaUsuariosComponent,

    // MasterConsultaFundosComponent,

    MasterConsultaClientesComponent,

    MasterConfirmedMessageComponent,

    MasterCompArrayFormClientsComponent,

    MasterVisualizarMeuCadastroComponent,

    ParametersSearchSecurityPortfolioMenuComponent,

    MasterAssociarFundosComponent,

    MasterAccessProfileComponent,

    EditUserComponent,

    MasterMasterGroupsComponent,

    MasterMasterGroupsUsersComponent,
    PresentationCardComponent

    // MasterMasterGroupsFundosComponent,
  ],
  exports: [
    // palmyra-needle-angular-add-screen-export Do not delete this line. Palmyra will add exports here

    MasterVisualizarUsuarioComponent,

    MasterSearchUserComponent,

    MasterSearch1Component,

    MasterSearch0Component,

    MasterPerfilUsuarioComponent,

    MasterPerfilAcessoComponent,

    MasterHomeComponent,

    MasterMasterComponent,

    MasterFundosComponent,

    MasterEdit5Component,

    MasterEdit1Component,

    MasterEdit0Component,

    MasterCreateUserComponent,

    MasterCreateUserWizardComponent,

    MasterConsultaUsuariosComponent,

    MasterVisualizarMeuCadastroComponent,

    ParametersSearchSecurityPortfolioMenuComponent,

    MasterConsultaClientesComponent,

    MasterConfirmedMessageComponent,

    MasterCompArrayFormClientsComponent,

    MasterAssociarFundosComponent,

    MasterAccessProfileComponent,

    MasterMasterGroupsComponent,

    MasterMasterGroupsUsersComponent,
    PresentationCardComponent
  ],
})
export class MasterModule { }
